import { render, staticRenderFns } from "./ModalEditTag.vue?vue&type=template&id=bf40890e&scoped=true&"
import script from "./ModalEditTag.vue?vue&type=script&lang=js&"
export * from "./ModalEditTag.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditTag.vue?vue&type=style&index=0&id=bf40890e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf40890e",
  null
  
)

export default component.exports